import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

export const cache: InMemoryCache = new InMemoryCache();

export const createApolloLink = (getToken: () => Promise<string>) => {
  const url = process.env.REACT_APP_XENIA_API_URL as string;

  const authLink = setContext(async (_, { headers }) => {
    const token = await getToken();
    return { headers: { ...headers, Authorization: token } };
  });

  const httpLink = new HttpLink({ uri: url });

  return authLink.concat(httpLink);
};

let apolloClientInstance: ApolloClient | null = null;

const getApolloClient = (getToken: () => Promise<string>) => {
  if (!apolloClientInstance) {
    apolloClientInstance = new ApolloClient({
      link: createApolloLink(getToken),
      cache,
      defaultOptions: {
        watchQuery: { fetchPolicy: 'cache-and-network' },
        query: { fetchPolicy: 'network-only' }
      }
    });
  }

  return apolloClientInstance;
};

export default getApolloClient;
